import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {SummaryFieldModule} from '../../../../../../core/component/summary-field/summary-field.module';
import {BmiSummaryFieldComponent} from './bmi-summary-field.component';
import {BmiLabelModule} from "../bmi-label/bmi-label.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        SummaryFieldModule,
        BmiLabelModule,
    ],
    declarations: [
        BmiSummaryFieldComponent
    ],
    exports: [
        BmiSummaryFieldComponent
    ]
})
export class BmiSummaryFieldModule {}
